/*!
 * Free Ride Auto-Add — DISABLED 2026-07-06
 *
 * The July 4th "Free Ride" promo has ended. Bags and USA caps are no longer
 * bundled with paddles. This file remains as a no-op stub so any cached theme
 * references resolve cleanly, but it performs no cart mutation.
 *
 * Companion cleanup:
 *   - Automatic discount DiscountAutomaticNode/1677460406564 (backpack) →
 *     deactivated via scripts/_freeride_deactivate.js
 *   - Automatic discount DiscountAutomaticNode/1681364549924 (USA cap) →
 *     expired 2026-07-06T06:59:59Z (Shopify enforced)
 *   - Snippet snippets/free-ride-autoadd.liquid → kill switch set to false
 *   - Landing page /pages/free-ride → body replaced with promo-ended notice
 *
 * If a future bundle needs an auto-add helper, restore from git history
 * rather than reviving in place — the variant IDs and product tags will
 * almost certainly need to change.
 */
(function () {
  'use strict';
  try {
    window.FreeRide = Object.assign(window.FreeRide || {}, {
      _disabled: true,
      _disabledAt: '2026-07-06',
      _reason: 'July 4th Free Ride promo ended; bags are no longer free.'
    });
  } catch (e) { /* no-op */ }
})();
